import AdminSettings from "./AdminSettings";
import Categories from "./Categories";
import FeaturedTeams from "./FeaturedTeams";
import RecommendedDeals from "./RecommendedDeals";

export { Categories, FeaturedTeams, RecommendedDeals };
export default AdminSettings;
